import { useState } from "react";
import { MagnifyingGlass, Package, Truck, CheckCircle, Clock } from "@phosphor-icons/react";
import { api, formatPrice, formatApiErrorDetail } from "../lib/api";

const STATUS_LV = { new: "Jauns — gaida apstrādi", processing: "Apstrādē", shipped: "Nosūtīts", done: "Izpildīts" };
const STATUS_ICON = { new: Clock, processing: Package, shipped: Truck, done: CheckCircle };

export default function OrderTrackingPage() {
  const [code, setCode] = useState("");
  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const track = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setLoading(true);
    setError("");
    setOrder(null);
    try {
      const { data } = await api.get(`/orders/track/${encodeURIComponent(code.trim())}`);
      setOrder(data);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const Icon = order ? (STATUS_ICON[order.status] || Clock) : Clock;

  return (
    <div className="mx-auto max-w-2xl px-4 py-12">
      <h1 className="text-center font-heading text-3xl md:text-4xl font-bold tracking-tight">Pasūtījuma statuss</h1>
      <p className="mt-2 text-center text-sm text-slate-500">Ievadiet pasūtījuma kodu (piem., DG-1001), ko saņēmāt apstiprinājumā.</p>
      <p className="mt-2 text-center text-xs text-slate-400">Demo režīmā var atrast tikai šajā pārlūkā izveidotus pasūtījumus.</p>
      <form onSubmit={track} className="mt-8 flex gap-3">
        <input data-testid="track-code-input" value={code} onChange={(e) => setCode(e.target.value)} placeholder="DG-1001"
          className="flex-1 border border-slate-300 px-4 py-3 text-sm font-mono uppercase focus:outline-none focus:ring-2 focus:ring-blue-500" />
        <button data-testid="track-submit-btn" type="submit" disabled={loading}
          className="btn-industrial inline-flex items-center gap-2 bg-[#2E86D1] px-6 py-3 text-sm font-semibold text-white hover:bg-[#1F6DB2] disabled:opacity-50">
          <MagnifyingGlass size={18} /> {loading ? "Meklē..." : "Pārbaudīt"}
        </button>
      </form>
      {error && <p data-testid="track-error" className="mt-4 text-center text-sm font-semibold text-red-500">{error}</p>}
      {order && (
        <div data-testid="track-result" className="mt-8 rounded-2xl border border-border bg-white p-6">
          <div className="flex items-center gap-4">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-blue-50"><Icon size={28} className="text-[#2E86D1]" /></span>
            <div>
              <p className="font-heading text-xl font-bold">{order.number}</p>
              <p data-testid="track-status" className="text-sm font-semibold text-[#2E86D1]">{STATUS_LV[order.status] || order.status}</p>
            </div>
          </div>
          <div className="mt-6 grid grid-cols-2 gap-4 text-sm">
            <div className="rounded-xl bg-[#F4F8FC] p-4"><p className="text-xs text-slate-500">Izveidots</p><p className="mt-0.5 font-semibold">{new Date(order.created_at).toLocaleDateString("lv-LV")}</p></div>
            <div className="rounded-xl bg-[#F4F8FC] p-4"><p className="text-xs text-slate-500">Pozīcijas</p><p className="mt-0.5 font-semibold">{order.items_count} gab</p></div>
            <div className="rounded-xl bg-[#F4F8FC] p-4"><p className="text-xs text-slate-500">Piegāde</p><p className="mt-0.5 font-semibold">{order.delivery_method === "courier" ? "Kurjers" : "Saņemšana noliktavā"}</p></div>
            <div className="rounded-xl bg-[#F4F8FC] p-4"><p className="text-xs text-slate-500">Summa ar PVN</p><p className="mt-0.5 font-semibold">{formatPrice(order.total)}</p></div>
          </div>
        </div>
      )}
    </div>
  );
}
